var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import BaseModel from "../BaseModel";
var OfferModel = /** @class */ (function (_super) {
    __extends(OfferModel, _super);
    function OfferModel(data) {
        var _this = _super.call(this, data) || this;
        var hydrated = _super.prototype.useHydrator.call(_this, data);
        _this.active = hydrated.active;
        _this.allDay = hydrated.allDay;
        _this.amount = hydrated.amount;
        _this.assetId = hydrated.assetId;
        _this.base = hydrated.base;
        _this.cancelled = hydrated.cancelled;
        _this.couponCode = hydrated.couponCode;
        _this.code = hydrated.code;
        _this.crDate = hydrated.crDate;
        _this.customerBase = hydrated.customerBase;
        _this.definitionId = hydrated.definitionId;
        _this.description = hydrated.description;
        _this.discountId = hydrated.discountId;
        _this.endComps = hydrated.endComps;
        _this.excludeCustomersList = hydrated.excludeCustomersList;
        _this.forLineItem = hydrated.forLineItem;
        _this.forOrder = hydrated.forOrder;
        _this.isEvent = hydrated.isEvent;
        _this.itemTypes = hydrated.itemTypes;
        _this.items = hydrated.items;
        _this.locations = hydrated.locations;
        _this.maxRedemptions = hydrated.maxRedemptions;
        _this.minBillAmount = hydrated.minBillAmount;
        _this.minItemCount = hydrated.minItemCount;
        _this.mobileImg = hydrated.mobileImg;
        _this.modDate = hydrated.modDate;
        _this.name = hydrated.name;
        _this.numIssued = hydrated.numIssued;
        _this.numRedemptions = hydrated.numRedemptions;
        _this.onOnline = hydrated.onOnline;
        _this.onRegister = hydrated.onRegister;
        _this.priceDelta = hydrated.priceDelta;
        _this.redemptions = hydrated.redemptions;
        _this.initialRedemptions = _this.redemptions;
        _this.rewardId = hydrated.rewardId;
        _this.smsText = hydrated.smsText;
        _this.target = hydrated.target;
        _this.useCustomersList = hydrated.useCustomersList;
        _this.validForDays = hydrated.validForDays;
        _this.rewardFlags = hydrated.rewardFlags;
        _this.type = hydrated.type;
        _this.uniqueId = _this.generateUniqueId(hydrated);
        _this.__mc = "OfferModel";
        return _this;
    }
    OfferModel.prototype.hydrate = function (data) {
        var offer = {};
        offer.active = !!parseInt(data.active);
        offer.allDay = !!parseInt(data.all_day);
        offer.amount = parseInt(data.amount) || null;
        offer.assetId = data.asset_id || null;
        offer.base = data.base || null;
        offer.cancelled = !!parseInt(data.cancelled);
        offer.couponCode = data.coupon_code || null;
        offer.code = parseInt(data.code) || null;
        offer.crDate = data.cr_date || null;
        offer.customerBase = data.customer_base || null;
        offer.definitionId = data.definition_id || null;
        offer.description = data.description || null;
        offer.discountId = data.discount_id || null;
        offer.endComps = (data.end_comps) ? data.end_comps.timestamp : null;
        offer.excludeCustomersList = data.exclude_customers_list || null;
        offer.forLineItem = data.for_lineitem || null;
        offer.forOrder = data.for_order || null;
        offer.isEvent = data.is_event || null;
        offer.itemTypes = data.item_types || null;
        offer.items = data.items || null;
        offer.locations = data.locations || null;
        offer.maxRedemptions = parseInt(data.max_redemptions) || 0;
        offer.minBillAmount = parseInt(data.min_bill_amount);
        offer.minItemCount = data.min_item_count || null;
        offer.mobileImg = data.mobile_img || null;
        offer.modDate = data.mod_date || null;
        offer.name = data.name || null;
        offer.numIssued = parseInt(data.num_issued) || null;
        offer.numRedemptions = parseInt(data.num_redemptions) || 0;
        offer.onOnline = data.on_online || null;
        offer.onRegister = !!parseInt(data.on_register);
        offer.priceDelta = parseInt(data.priceDelta) || null;
        offer.redemptions = parseInt(data.redemptions) || 0;
        offer.rewardId = parseInt(data.reward_id) || null;
        offer.smsText = data.sms_text || null;
        offer.target = data.target || null;
        offer.useCustomersList = data.use_customers_list || null;
        offer.validForDays = parseInt(data.valid_for_days) || null;
        offer.rewardFlags = data.reward_flags || null;
        offer.type = (data.hasOwnProperty("type")) ? parseInt(data.type) : null;
        return offer;
    };
    // TODO move this into base model (generate hash maybe?)
    OfferModel.prototype.generateUniqueId = function (offer) {
        var id = offer.rewardId || offer.code;
        var random = Math.random() * 10000;
        return id + "-" + random;
    };
    OfferModel.prototype.assignId = function (customerBase) {
        if (this.rewardId) {
            this.id = customerBase + "-" + this.rewardId;
        }
    };
    OfferModel.prototype.isValid = function () {
        if (this.redemptions >= this.maxRedemptions) {
            return false;
        }
        // item offer with no items, hide (NULL means any)
        if (this.target === "item" /* ITEM */ && (this.items && !this.items.length) && this.rewardFlags !== 2 /* RewardFlagVisits */) {
            return false;
        }
        // TODO check for valid time frame
        return true;
    };
    OfferModel.prototype.wasRedeemed = function () {
        var currentRedemptions = this.redemptions;
        var initialRedemptions = this.initialRedemptions;
        return (currentRedemptions !== initialRedemptions);
    };
    OfferModel.prototype.redeem = function () {
        this.redemptions++;
    };
    OfferModel.prototype.cancel = function () {
        this.redemptions--;
    };
    // TODO: the following code is copied from the discount model
    // refactor to have offer model and discount model be the same
    // model or inherit from the same class
    OfferModel.prototype.calculatePercent = function (amount, price) {
        return price * (amount / 1000);
    };
    OfferModel.prototype.calculateDiscountForItem = function (item, optionExceptions) {
        var discountedPrice = 0;
        var itemPrice = item.getSingleItemTotal();
        switch (this.type) {
            case 1 /* PERCENT */: {
                discountedPrice = this.calculatePercent(this.amount, itemPrice);
                break;
            }
            case 0 /* AMOUNT */: {
                discountedPrice = this.amount;
                break;
            }
            case 2 /* TARGET_PRICE */: {
                var itemPrice_1 = (!item.bundle) ? item.getBasePrice(optionExceptions) : item.bundle.getBundleBasePrice(optionExceptions);
                discountedPrice = itemPrice_1 - this.amount;
                break;
            }
        }
        return discountedPrice;
    };
    OfferModel.prototype.discountPriceForItem = function (item, optionExceptions) {
        var discount = this.calculateDiscountForItem(item, optionExceptions);
        return discount;
    };
    OfferModel.prototype.export = function () {
        return {
            'base': this.base,
            'reward_id': this.rewardId,
            'reward_flags': this.rewardFlags,
            'items': this.items,
        };
    };
    OfferModel.prototype.hydrateFromStore = function (data) {
        return data;
    };
    return OfferModel;
}(BaseModel));
export default OfferModel;



//////////////////
// WEBPACK FOOTER
// ./src/models/loyalty/OfferModel.ts
// module id = CzQd
// module chunks = 18